import React, {useEffect} from "react"
import PropTypes from 'prop-types'
import { useSelector, useDispatch } from "react-redux";
import { getStoreSettings as onGetStoreSettings } from "store/products/actions"
import {
  Card,
  CardBody,
  Col,
  Row,
} from "reactstrap"
import Editable from "react-bootstrap-editable"
import { postEditSetting } from "helpers/backend_helper"

const GeneralSettings = props => {

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(onGetStoreSettings(true))
  }, [dispatch]);

  const { settings} = useSelector(state => ({
    settings: state.Products.settings,
  }))

  const validateField = (value , type) => {
    if(type == 'number'){
      if(!isNumber(value)){
        return "  Please enter a valid number"
      }
    }
  }

  function isNumber(num){
    if(Number(num) || num == 0){
      return true;
    }
    else{
      return false;
    }
  }

  function updateDetails(value, id){
    postEditSetting({
      id:id,
      value:value
    }).then(resp => {
      //console.log('resp:'+JSON.stringify(resp))
      dispatch(onGetStoreSettings(false))
    })
  }

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Card>
            <CardBody>
            {(settings || []).map((formRow, key) => (
              <Row key={key} className="py-2">
                <Col lg={4}>
                  {formRow.settingdetails}
                </Col>
                <Col lg={5} className="d-flex flex-row">
                  <Editable
                    ajax={null}
                    alwaysEditing={false}
                    className="d-flex flex-row"
                    disabled={false}
                    editText="Edit"
                    id={formRow.id}
                    initialValue={formRow.settingvalue}
                    isValueClickable={true}
                    label={null}
                    mode="inline"
                    onSubmit={null}
                    options={formRow.settingoptions ? formRow.settingoptions.split(','): []}
                    placement="top"
                    renderCancelElement={null}
                    renderConfirmElement={null}
                    showText
                    type={formRow.settingfieldtype == 'number' ? "textfield" : formRow.settingfieldtype}
                    validate={(value) => {
                      return validateField(value,formRow.settingfieldtype)
                    }}
                    onValidated={(validValue) => {
                      updateDetails(validValue,formRow.id)
                      //console.log(`Valid Value: ${validValue}`);
                    }}
                  />
                </Col>
              </Row>
              ))}
            </CardBody>
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  )
}

GeneralSettings.propTypes = {
}

export default GeneralSettings
